import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Typography } from '@material-ui/core';

import {
    togglePrimaryPanelCompact,
    toggleSecondaryPanelCompact
} from '../../../redux/panel/Actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PanelHeader from './PanelHeader';

class PanelContainer extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        header: PropTypes.oneOfType([PropTypes.string, PropTypes.func]), // func is react element wrapper
        isPrimary: PropTypes.bool,
        // Redux state
        isCompact: PropTypes.bool,
        // Redux dispatch
        onTogglePanelCompact: PropTypes.func.isRequired
    };

    static defaultProps = {
        isPrimary: false,
        isCompact: false
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, header, icon, isCompact, onTogglePanelCompact, children } =this.props;
        const HeaderWrapper = header;
        return (
            <div className={classnames(classes.container, isCompact && classes.containerCompact)}>
                {
                    header &&
                        _.isString(header) ?
                        <PanelHeader
                            isCompact={isCompact}
                            onClick={onTogglePanelCompact}
                        >
                            { icon }
                            <Typography
                                variant="h4"
                                color="textPrimary"
                            >
                                {header}
                            </Typography>
                        </PanelHeader> :
                        <HeaderWrapper
                            isCompact={isCompact}
                            onClick={onTogglePanelCompact}
                        />
                }
                {children}
            </div>
        );
    }
}

const style = theme => ({
    container: {
        width: '100%',
        backgroundColor: theme.palette.background.main,
        boxSizing: 'border-box',
        borderRadius: theme.constants.radius.md,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        // backdropFilter: 'blur(6px)'
        transition: theme.transitions.create('max-height', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        maxHeight: '100%'
    },
    containerCompact: {
        maxHeight: theme.constants.panelHeader,
        transition: theme.transitions.create('max-height', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    }
});

const mapStateToProps = (state, ownProps) => {
    const panelsState = state.panels;
    return {
        isCompact: ownProps.isPrimary ?
            (panelsState.primaryPanel ? panelsState.panels[panelsState.primaryPanel].compact : true) :
            (panelsState.secondaryPanel ? panelsState.panels[panelsState.secondaryPanel].compact : true)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onTogglePanelCompact: () => dispatch(ownProps.isPrimary ? togglePrimaryPanelCompact() : toggleSecondaryPanelCompact())
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(PanelContainer);